import React, { useState } from 'react';
import PropTypes from 'prop-types';

import { Input } from 'components/ui';

import * as Styled from './Prices.styles';
import { NumberInput } from 'components/ui/NumberInput/NumberInput';

export const Prices = ({ form }) => {
  const { values, setFieldValue, errors } = form;

  const [isAmountToPayNetFocused, setIsAmountToPayNetFocused] = useState(false);
  const [isAmountToPayFocused, setIsAmountToPayFocused] = useState(false);

  return (
    <Styled.Wrapper>

      <Styled.Price>
        <span>Do zapłaty netto:</span>
        <NumberInput
          label={isAmountToPayNetFocused || values.amountToPayNet ? null : '0,00'}
          value={values.amountToPayNet}
          onChange={(value) => setFieldValue('amountToPayNet', value)}
          onFocus={() => setIsAmountToPayNetFocused(true)}
          onBlur={() => setIsAmountToPayNetFocused(false)}
          error={errors.amountToPayNet}
        />
      </Styled.Price>


      <Styled.Price className="big">
        <span>Do zapłaty brutto:</span>
        <NumberInput
          label={isAmountToPayFocused || values.amountToPay ? null : '0,00'}
          value={values.amountToPay}
          onChange={(value) => setFieldValue('amountToPay', value)}
          onFocus={() => setIsAmountToPayFocused(true)}
          onBlur={() => setIsAmountToPayFocused(false)}
          error={errors.amountToPay}
        />
      </Styled.Price>
    </Styled.Wrapper>
  );
};

Prices.propTypes = {
  form: PropTypes.object.isRequired,
  isAdvancedView: PropTypes.bool,
};
